export default "__VITE_ASSET__BnRxSvyl__"